import React, { useEffect, useState } from 'react';
import {connect} from 'react-redux';
import styled from "styled-components";
import {getSuppliers} from '../../../../store/actions/dashboardAction';
import FilterListIcon from '@material-ui/icons/FilterList'
import {
	Table,
	Row,
	Col,
	ButtonGroup,
	Button,
	Modal,
	Form,
	Card,
	Collapse,
	ToggleButton,
	Toast,
} from "react-bootstrap";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import SelectAndSearchComponent from "../../../../components/SelectAndSearchComponent/SelectAndSearchComponent";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { Link } from "react-router-dom";
import { fetchWarehouses, deleteWarehouse } from '../services/warehouseService';

const TableBodyWidth = styled.div`
  table tr th {
    white-space: nowrap;
    width: initial;
    scrollbar-width: none;
  }
  ::-webkit-scrollbar {
    display: none;
  }
`;

const WarehouseList = (props) => {
  const [warehouses, setWarehouses] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10;

  const [showToast, setShowToast] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const [Error, setError] = useState(false);
  const [deleteItemName, setDeleteItemName] = useState('');
  const [toastBgColor, setToastBgColor] = useState('bg-success');
  const [toastMessage, setToastMessage] = useState("Delete successful");
  const [editedItem, setEditedItem] = useState({});
  const [dialogDelete, setDialogDelete] = useState(false);

	const [showFilter, setShowFilter] = useState(true);
	const [filters, setFilters] = useState({
		supplier: '',
		location: '',
    name: '',
		is_ds_warehouse: null,
	});
	const IsDSWarehouseOptions = [
		{
			value: null,
			key: 'Select'
		},
		{
			value: true,
			key: 'Yes'
		},
		{
			value: false,
			key: 'No'
		}
	]
	const [filtersDirty, setFiltersDirty] = useState(false);
	// Handling filter changes
	const handleFilterChange = (field, value, autoApply = false) => {
		setFilters({
			...filters,
			[field]: value
		});
		// Auto-apply filters for select components
		if (autoApply) {
			setPage(1);
			setTimeout(() => {
				setFiltersDirty(prev => !prev);
			}, 0);
		}
	};

	// Apply filters
	const applyFilters = () => {
		setPage(1);
		setFiltersDirty(!filtersDirty);
	};
  
	// Handle keyboard events
	const handleKeyPress = (e) => {
		if (e.key === 'Enter') {
			applyFilters();
		}
	};

	// Reset filters
	const resetFilters = () => {
		setPage(1);
		setFilters({
			supplier: null,
			location: '',
			is_ds_warehouse: null,
		});
		setFiltersDirty(!filtersDirty);
	};

  const handleDialogDelete = (status = false, data = null) => {
    if (data !== null) {
      setEditedItem(data);
      setDeleteItemName(data.name);
    } else {
      setDeleteItemName('');
    }

    setDialogDelete(status);

    if (!status)
      setEditedItem({});
  };

  const softDeleteProduct = async () => {
    const id = editedItem.id;
    console.log(id)
    const itemRow = document.getElementById(`item-row-${id}`);

    setIsLoading(true);
    setShowToast(false);

    setTimeout(() => {
      document.body.click();
      setIsLoading(false);
      setShowToast(true);
      itemRow.remove();
    }, 750);
    try {
      await deleteWarehouse(id)
        .then((response) => response.json())
        .then(response => {
          setTimeout(() => {
            document.body.click();
            setIsLoading(false);
            setShowToast(true);
            itemRow.remove();
          }, 750)
        })
      setDialogDelete(false);
    } catch (error) {
      console.log(error);
      setDialogDelete(false);
    }
  };

  useEffect(() => {
    const getWarehouses = async () => {
        if (isLoading) return;
        setIsLoading(true);
        setError(null);
        try {
            const activeFilters = {};
            Object.entries(filters).forEach(([key, value]) => {
                if (value !== '') {
                    activeFilters[key] = value;
                }
            });
            const filtersToSend = Object.keys(activeFilters).length > 0 ? activeFilters : undefined;
            // console.log("filtersToSend >>>>>>>>>>>>>>>>>> ", filtersToSend)
            const data = await fetchWarehouses(page, limit, filtersToSend);
            if (data && data.list) {
                setWarehouses(data.list);
                setTotalPages(data.total_pages);
            }
        } catch (err) {
            console.error('Error fetching Warehouses:', err);
            setError('Failed to fetch Warehouses. Please try again.');
        } finally {
            setIsLoading(false);
        }
    };
    getWarehouses();
  }, [page, filtersDirty]);

	useEffect(() => {
		props.getSuppliers({});
	}, []);

  const addWarehousePage = () => {
    window.location.href = "/admin/warehouse/add";
  };

  return (
    <>
	    {/* Filter */}
	    <Row className="mb-3">
		    <Col>
			    <Button
				    variant="outline-primary"
				    onClick={() => setShowFilter(!showFilter)}
				    className="d-flex align-items-center"
			    >
				    <FilterListIcon className="mr-1"/>
				    {showFilter ? 'Hide Filters' : 'Show Filters'}
			    </Button>
		    </Col>
	    </Row>

	    <Collapse in={showFilter}>
		    <Card className="mb-3">
			    <Card.Body>
				    <Row>
					    <Col md={3} className="mb-4">
						    <Form.Group>
							    <Form.Label>Name</Form.Label>
							    <Form.Control
								    type="text"
								    value={filters.name}
								    onChange={(e) => handleFilterChange('name', e.target.value)}
								    onKeyPress={handleKeyPress}
								    placeholder="Filter by name"
							    />
						    </Form.Group>
					    </Col>
					    <Col md={3} className="mb-4">
						    <Form.Group>
							    <Form.Label>Supplier</Form.Label>
							    <SelectAndSearchComponent
								    options={props.suppliers}
								    value={filters.supplier}
								    onChange={(e) => handleFilterChange('supplier', e, true)}
								    placeholder="Select Supplier"
								    getOptionValue={(opt) => opt.store_users[0].first_name}
								    getOptionLabel={(supplier) => (
									    <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
										    {supplier.store_users[0].first_name}
									    </div>
								    )}
							    />
						    </Form.Group>
					    </Col>
					    <Col md={3} className="mb-4">
						    <Form.Group>
							    <Form.Label>Location</Form.Label>
							    <Form.Control
								    type="text"
								    value={filters.location}
								    onChange={(e) => handleFilterChange('location', e.target.value)}
                    onKeyPress={handleKeyPress}
								    placeholder="Filter by location"
							    />
						    </Form.Group>
					    </Col>
					    <Col md={3} className="mb-4">
						    <Form.Group>
							    <Form.Label>Is DS warehouse?</Form.Label>
							    <SelectAndSearchComponent
								    options={IsDSWarehouseOptions}
								    value={filters.is_ds_warehouse}
								    onChange={(e) => handleFilterChange('is_ds_warehouse', e, true)}
								    placeholder="DS warehouse"
								    getOptionValue={(opt) => opt.key}
								    getOptionLabel={(opt) => (
									    <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
										    {opt.key}
									    </div>
								    )}
							    />
						    </Form.Group>
					    </Col>
				    </Row>
				    <Row className="mt-2">
					    <Col className="d-flex justify-content-end">
						    <Button
							    variant="secondary"
							    className="mr-2"
							    onClick={resetFilters}
						    >
							    Reset
						    </Button>
						    <Button
							    variant="primary"
							    onClick={applyFilters}
						    >
							    Apply Filters
						    </Button>
					    </Col>
				    </Row>
			    </Card.Body>
		    </Card>
	    </Collapse>

      <Row>
        <Col lg={3}>
          <Button variant="success" onClick={addWarehousePage}>
            Add Warehouse
          </Button>
        </Col>
        <Col lg={9}>
          <ButtonGroup toggle className="pull-right">
            <ToggleButton type="radio" variant="primary" name="radio" onClick={() => setPage(1)} disabled={page === 1}>
              First
            </ToggleButton>
            <ToggleButton type="radio" variant="primary" name="radio" onClick={() => {
              if (isLoading) return;
              setPage(prev => Math.max(prev - 1, 1));
            }} disabled={page === 1}>
              <ArrowBackIosIcon style={{ fontSize: "18px" }} />
            </ToggleButton>
            <ToggleButton type="radio" variant="outline-dark" disabled name="radio">
              Page {page} of {totalPages}
            </ToggleButton>
            <ToggleButton type="radio" variant="primary" name="radio" onClick={() => {
              if (isLoading) return;
              setPage(prev => Math.min(prev + 1, totalPages));
            }} disabled={page === totalPages}>
              <NavigateNextIcon style={{ fontSize: "25px" }} />
            </ToggleButton>
            <ToggleButton type="radio" variant="primary" name="radio" onClick={() => setPage(totalPages)} disabled={page === totalPages}>
              Last
            </ToggleButton>
          </ButtonGroup>
        </Col>
      </Row>
      <TableBodyWidth className="table-responsive" style={{ height: "calc(100vh - 280px)", marginTop: "5px" }}>
        <Table striped bordered hover>
          <thead>
            <tr>
              <th>ID</th>
              <th>Name</th>
              <th>Supplier Name</th>
              <th>Address</th>
              <th>Is DS Warehouse</th>
              <th>Is Main Warehouse</th>
              <th>Comment</th>
	            <th>Distance to DS warehouse</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {warehouses.map((warehouse, key) => (
              <tr key={key} id={`item-row-${warehouse.id}`}>
                <td>{warehouse.id}</td>
                <td>{warehouse.name}</td>
                <td>{warehouse.supplier?.first_name || 'N/A'}</td>
                <td>{warehouse.address}</td>
                <td>{warehouse.is_ds_warehouse ? 'Yes' : 'No'}</td>
                <td>{warehouse.is_main_warehouse ? 'Yes' : 'No'}</td>
                <td>{warehouse.comment}</td>
	              <td>{warehouse.distance_to_ds_warehouse}</td>
                <td>
                  <div className="d-flex flex-row" style={{ height: '100%' }}>
                    <Link target="_blank" to={{ pathname: '/admin/warehouse/update/' + warehouse.id, state: { id: warehouse.id } }}>
                      <Button variant="info" type="submit" style={{ height: '100%' }} >
                        <EditIcon></EditIcon>
                      </Button>
                    </Link>
                    <Button className="ml-1" variant="danger" onClick={() => handleDialogDelete(true, warehouse)}><DeleteIcon /></Button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </TableBodyWidth>


      <Modal
        show={dialogDelete}
        onHide={handleDialogDelete}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete product</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure want to delete <strong>{deleteItemName}</strong>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleDialogDelete(false)}>
            Close
          </Button>
          <Button variant="danger" onClick={() => softDeleteProduct()}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <Toast
        className={toastBgColor}
        onClose={() => setShowToast(false)}
        show={showToast}
        delay={3000}
        autohide
        style={{
          position: "fixed",
          top: 70,
          right: 35,
          zIndex: 1041,
        }}
      >
        <Toast.Header>
          <strong className="mr-auto">{toastMessage}</strong>
        </Toast.Header>
      </Toast>
    </>
  );
};

const mapStateToProps = (state) => ({
	suppliers: state.dashboardReducer.suppliers,
});

const mapDispatchToProps = (dispatch) => ({
	getSuppliers: (data) => getSuppliers(data, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(WarehouseList);